import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AgentSidebar from '../components/AgentSidebar';

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

const STAGE_LABELS = {
  LEAD: 'Lead', AGENT_ASSIGNED: 'Assigned', DOCUMENT_COLLECTION: 'Document Review',
  INITIAL_FEE_PAID: 'Fee Paid', SUBMITTED: 'Submitted', OFFER_RECEIVED: 'Offer Received',
  DEPOSIT_PAID: 'Deposit Paid', OFFICIAL_ACCEPTANCE: 'Accepted', VISA_APPLICATION: 'Visa Processing',
  VISA_OUTCOME: 'Visa Outcome', TRAVEL_PREP: 'Travel Prep', ARRIVED: 'Arrived', CLOSED: 'Closed',
};

export default function AgentApplicationsPage() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [stage, setStage] = useState('');

  const token = localStorage.getItem('token');

  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (stage) params.set('stage', stage);
    fetch(`${API_BASE}/admin/applications?${params.toString()}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => r.json())
      .then((json) => setApplications(json.success ? json.data : []))
      .finally(() => setLoading(false));
  }, [search, stage]);

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen">
      <AgentSidebar />
      <main className="pt-16 md:pt-2 md:ml-64 min-h-screen p-8">
        <h2 className="text-3xl font-bold text-[#00255a] mb-1">My Applications</h2>
        <p className="text-[#64748b] mb-8">Applications assigned to you (or your full caseload, if pipeline visibility is enabled).</p>

        <div className="flex flex-wrap gap-4 mb-6">
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search by name or email..."
            className="flex-1 min-w-[240px] px-4 py-3 bg-white border border-[#e2e8f0] rounded-xl outline-none focus:ring-2 focus:ring-[#00255a]/10"
          />
          <select value={stage} onChange={(e) => setStage(e.target.value)} className="px-4 py-3 bg-white border border-[#e2e8f0] rounded-xl outline-none">
            <option value="">Any Stage</option>
            {Object.entries(STAGE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>

        <div className="bg-white rounded-2xl border border-[#e2e8f0] shadow-sm overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-[#f2f4f6]">
              <tr>
                {['Applicant', 'Type', 'Country', 'Stage', 'Submitted', ''].map((h) => (
                  <th key={h} className="px-6 py-4 text-xs uppercase text-[#64748b]">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#e2e8f0]">
              {loading ? (
                <tr><td colSpan="6" className="p-12 text-center text-[#64748b]">Loading...</td></tr>
              ) : applications.length === 0 ? (
                <tr><td colSpan="6" className="p-12 text-center text-[#64748b]">No applications assigned to you yet.</td></tr>
              ) : (
                applications.map((app) => (
                  <tr key={app.id} className="hover:bg-[#f7f9fb] transition-colors">
                    <td className="px-6 py-4 font-semibold text-[#0f172a]">{app.applicant?.fullName}</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase ${app.type === 'STUDY' ? 'bg-[#00255a]/10 text-[#00255a]' : 'bg-[#79161e]/10 text-[#862026]'}`}>
                        {app.type}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm">{app.opportunity?.country || '—'}</td>
                    <td className="px-6 py-4">
                      <span className="px-3 py-1.5 rounded-full text-[11px] font-bold bg-[#8fb3ff]/20 text-[#174388]">
                        {STAGE_LABELS[app.currentStage]}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-[#64748b]">{new Date(app.createdAt).toLocaleDateString()}</td>
                    <td className="px-6 py-4 text-right">
                      <Link to={`/agent/applications/${app.id}`} className="text-[#00255a] font-semibold text-sm hover:underline">View</Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
}